import { UiSchema } from "@rjsf/utils";

// groupInfoUiSchema, cobraAdminUiSchema, productsSoldUiSchema, enrollmentUiSchema, docUploadUiSchema

export const groupInfoUiSchema: UiSchema = {
  contactEmail: {
    "ui:placeholder": "your.email@example.com",
  },
  companyName: {},
  uniqueId: { "ui:widget": "NumericWidget" },
  companyTaxId: { "ui:widget": "TaxIdWidget" },
  companyType: {
    "ui:widget": "radio",
  },
  companyOrganizationDate: {},
  groupWebsite: {},
  companyAddress1: {},
  companyCity: {},
  companyState: {},
  companyZip: { "ui:widget": "NumericWidget" },
  isSameBillingAddress: {
    "ui:widget": "radio",
  },
  companyBillingAddress1: {
    "ui:widget": "hidden",
  },
  companyBillingCity: {
    "ui:widget": "hidden",
  },
  companyBillingState: {
    "ui:widget": "hidden",
  },
  companyBillingZip: {
    "ui:widget": "hidden",
  },
  hasTPA: {},
  nameOfTPA: {
    "ui:widget": "hidden",
  },
  emailOfTPA: {
    "ui:widget": "hidden",
    "ui:placeholder": "tpaemail@example.com",
  },
  policySignerName: {},
  policySignerTitle: {},
  policySignerEmail: {
    "ui:placeholder": "policysigner@example.com",
  },
  policySignerPhone: {
    "ui:widget": "PhoneWidget",
  },
  policySignerAsPortalContact: {},
  portalContactName: {
    "ui:widget": "hidden",
  },
  portalContactTitle: {
    "ui:widget": "hidden",
  },
  portalContactEmail: {
    "ui:widget": "hidden",
    "ui:placeholder": "portalcontact@example.com",
  },
  portalContactPhone: {
    "ui:widget": "hidden",
  },
  addPrimaryContact: {},
  additionalContactName: {
    "ui:widget": "hidden",
  },
  additionalContactTitle: {
    "ui:widget": "hidden",
  },
  additionalContactEmail: {
    "ui:widget": "hidden",
    "ui:placeholder": "additionalcontact@example.com",
  },
  additionalContactPhone: {
    "ui:widget": "hidden",
  },
  billingContact: {},
  billingContactName: {
    "ui:widget": "hidden",
  },
  billingContactTitle: {
    "ui:widget": "hidden",
  },
  billingContactEmail: {
    "ui:widget": "hidden",
    "ui:placeholder": "billingcontact@example.com",
  },
  billingContactPhone: {
    "ui:widget": "hidden",
  },
  prefferedPaymentMethod: {},
  hasMultipleLocations: {},
  numberOfLocations: {
    "ui:widget": "hidden",
  },
  billingPreference: {
    "ui:widget": "hidden",
  },
  locationTemplate: {
    "ui:widget": "hidden",
  },
};

export const cobraAdminUiSchema: UiSchema = {
  sendCobra: {},
  cobraAdminName: {
    "ui:widget": "hidden",
  },
  cobraAdminEmail: {
    "ui:widget": "hidden",
    "ui:placeholder": "cobraadmin@example.com",
  },
  cobraAdminAddress: {
    "ui:widget": "hidden",
  },
  cobraAdminCity: {
    "ui:widget": "hidden",
  },
  cobraAdminState: {
    "ui:widget": "hidden",
  },
  cobraAdminZip: {
    "ui:widget": "hidden",
  },
};

export const productsSoldUiSchema: UiSchema = {
  productsSold: {
    "ui:widget": "CheckboxesWidget",
  },
  majorMedReset: {
    "ui:widget": "hidden",
  },
  isReplacingExistingGAP: {
    "ui:widget": "hidden",
  },
  currentCarrier: {
    "ui:widget": "hidden",
  },
  currentGAPCoverageType: {
    "ui:widget": "hidden",
  },
  currentGAPAddedBenefits: {
    "ui:widget": "hidden",
  },
  taxAndWageReport: {
    "ui:widget": "hidden",
  },
  ltdMedOrHospitalIndemnity: {
    "ui:widget": "hidden",
  },
  optiMedReplace: {
    "ui:widget": "hidden",
  },
  currentInsurer: {
    "ui:widget": "hidden",
  },
  hasDisabled: {
    "ui:widget": "hidden",
  },
  numberOfDisabledMembers: {
    "ui:widget": "hidden",
  },
  numberOfDisabledDependents: {
    "ui:widget": "hidden",
  },
  premiumsCollectedByPayrollDeduction: {
    "ui:widget": "hidden",
  },
  firstPayrollDeductionDate: {
    "ui:widget": "hidden",
  },
  deductionsPerYear: {
    "ui:widget": "hidden",
  },
  payPeriodsPerYear: {
    "ui:widget": "hidden",
  },
  deductionMonths: {
    "ui:widget": "hidden",
  },
  remittanceFrequency: {
    "ui:widget": "hidden",
  },
  minHoursPerWeek: {},
};

export const enrollmentUiSchema: UiSchema = {
  enrollmentPreference: {},
  ediContactName: {
    "ui:widget": "hidden",
  },
  ediContactEmail: {
    "ui:widget": "hidden",
    "ui:placeholder": "edicontact@example.com",
  },
  waitingPeriod: {},
  waiveWaitingPeriod: {},
  eligibleClasses: {},
  coverRetirees: {},
  includeEarlyRetirees: {
    "ui:widget": "hidden",
  },
  numberOfRetirees: {
    "ui:widget": "hidden",
  },
  openEnrollmentEndDate: {},
  idCardDistributionMethod: {},
  isCorporateMailingSame: {
    "ui:widget": "hidden",
  },
  cardMailingAddress: {
    "ui:widget": "hidden",
  },
  cardMailingCity: {
    "ui:widget": "hidden",
  },
  cardMailingState: {
    "ui:widget": "hidden",
  },
  cardMailingZip: {
    "ui:widget": "hidden",
  },
};

export const docUploadUiSchema: UiSchema = {};
